require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./basics-exporting-storybook.json") })
        }
      }, "path---basics-exporting-storybook");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---basics-exporting-storybook!./.cache/json/basics-exporting-storybook.json
// module id = 399
// module chunks = 231608221292675